import React from "react";
import InfoIcon from "../InfoIcon";
import "./index.css";
import { useTranslation } from "react-i18next";

const SubItem = ({ label, value, secondLabel, secondValue }) => (
  <div className="subitem">
    <span className="subitemspan">{label ? `${value} ${label}` : value}</span>
    {secondValue && (
      <span className="subitemspan">
        {secondLabel ? `${secondValue} ${secondLabel}` : secondValue}
      </span>
    )}
  </div>
);

const TotalBox = ({ title, items, showInfoIcon, infoText }) => (
  <div className="total-box">
    <div className="total-title">
      <h3>{title}</h3>
    </div>
    <div style={{ display: "flex", justifyContent: "center" }}>
      {items.map((item, index) => (
        <div key={index} className="item">
          {item.subtitle || item.noSubtitle ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              {item.subtitle && (
                <div className="sub-item">
                  <h4>{item.subtitle}</h4>
                  {showInfoIcon && <InfoIcon text={infoText} />}
                </div>
              )}
              {item.subitems && (
                <div className="subitem-box">
                  {item.subitems.map((subitem, subIndex) => (
                    <SubItem key={subIndex} {...subitem} />
                  ))}
                </div>
              )}
            </div>
          ) : (
            <SubItem {...item} />
          )}
        </div>
      ))}
    </div>
  </div>
);

const RightBox = ({ totals, lastUpdated }) => {
  const { t } = useTranslation();
  return (
    <div className="right-box">
      <div style={{ display: "flex", width: "100%" }}>
        {totals.map((total, index) => (
          <TotalBox key={index} {...total} />
        ))}
      </div>
      {lastUpdated && (
        <p className="last-updated">
          {t("LAST_UPDATED")}: {lastUpdated}
        </p>
      )}
    </div>
  );
};

export default RightBox;
